export default "__VITE_ASSET__Cws2NhgJ__"